import React, { Component } from "react";
import { connect } from "react-redux";
import ReactPasswordStrength from "react-password-strength";

// Components
// import HelmetHead from '../utils/HelmetHead'

// State
import { setpageTitle } from "../../store/actions/siteInfo";
import { updateCustomerPassword, passwordUpdateClearErrors } from "../../store/actions/user";

// CSS
import "../../css/password-strength.css";

class CustomerPasswordChange extends Component {
	constructor(props) {
		super(props);
		this.state = {
			current_password: "",
			new_password: "",
			new_password_2: ""
		};

		this.props.setpageTitle("Change Password");
	}

	componentWillUnmount() {
		this.props.passwordUpdateClearErrors();
	}

	handleInputChange(event) {
		event.preventDefault();
		this.setState({
			[event.target.id]: event.target.value
		});
	}

	handleKeyPress(event, item_id) {
		if (event.key === "Enter") {
			this.handleSubmit(event);
		}
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.updateCustomerPassword(this.state);
	}

	render() {
		const { success, errors } = this.props;

		return (
			<div>
				{/* <HelmetHead title="Change Password" /> */}
				<h1>Change Password</h1>

				{success ? (
					<div class="error msg_animate">You have successfully updated your password!</div>
				) : (
					<div>
						<div className="form-field half-field clear-float">
							<label htmlFor="current_password">Current Password:</label>

							{errors.current_password && <div className="error msg_animate">{errors.current_password}</div>}
							<input type="password" id="current_password" value={this.state.current_password} onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} />
						</div>

						<div className="floated-field-container">
							<div className="form-field half-field">
								<label htmlFor="new_password">New Password:</label>

								{errors.new_password && <div className="error msg_animate">{errors.new_password}</div>}
								<ReactPasswordStrength inputProps={{ id: "new_password", autoComplete: "off", value: this.state.new_password }} tooShortWord={"weak"} scoreWords={["weak", "okay", "good", "strong", "stronger"]} /* onKeyPress={e => this.handleKeyPress(e)} */ changeCallback={data => this.setState({ new_password: data.password })} />
							</div>
						</div>

						<div className="form-field half-field clear-float">
							<label htmlFor="new_password_2">Re-enter New Password:</label>

							{errors.new_password_2 && <div className="error msg_animate">{errors.new_password_2}</div>}
							<input type="password" id="new_password_2" value={this.state.new_password_2} onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} />
						</div>

						<div className="btn_container">
							{errors.general && <div className="error msg_animate">{errors.general}</div>}

							<button className="btn submit-btn" onClick={e => this.handleSubmit(e)}>
								<span>Submit</span>
							</button>
						</div>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		success: state.user.passwordUpdateSuccess,
		errors: state.user.passwordUpdateErrors,
		isLoading: state.user.isLoading
	};
};

export default connect(mapStateToProps, { updateCustomerPassword, passwordUpdateClearErrors, setpageTitle })(CustomerPasswordChange);



// WEBPACK FOOTER //
// ./src/components/customer/CustomerPasswordChange.js